const menuDe = {
    "add_to_cart": "In den Warenkorb legen",
    "add_to_order": "Zur Bestellung hinzufügen",
    "already_in_cart": "Bereits im Warenkorb",
    "update_order_item": "Aktualisierungsbestellung",
    "delete_order_item": "Element entfernen",
    "available_categories": "Menükategorien",
    "search_menu_placeholder": "Im Menü suchen",
    "guides": {
        "scan_qr": "Scannen Sie den QR-Code auf dem Tisch mit Ihrem Smartphone.",
        "order": "Bestellen Sie die ausgewählten Artikel von Ihrem Telefon aus.",
        "pay": "Bezahlen Sie einzeln oder alles auf einmal von Ihrem Handy aus.",
        "accept": "Weitermachen"
    },
    "index_image": "Indexbild",
    "menu_saved": "Menü gespeichert",
    "new_category": "Neue Kategorie",
    "menu_editor": "Editor-Menü",
    "new_item": "Neuer Artikel",
    "menu": "Speisekarte",
    "allergens": "Allergene",
    "generate_qr": "QR-Code generieren",
    "allergen_list": {
        "gluten": "Gluten",
        "crustaceans": "Krebstiere",
        "eggs": "Eier",
        "fish": "Fisch",
        "peanuts": "Erdnüsse",
        "soybeans": "Sojabohnen",
        "milk": "Milch",
        "nuts": "Nüsse",
        "celery": "Sellerie",
        "mustard": "Senf",
        "sesame": "Sesam",
        "sulphur_dioxide": "Schwefeldioxid",
        "lupin": "Lupine",
        "molluscs": "Weichtiere",
        "vegan": "Vegan"
    },
    "add_allergen": "Allergen hinzufügen",
    "auto_translate": "Menüübersetzung",
    "no_category_name": "In der aktuellen Sprache wurde kein Kategoriename angegeben.",
    "no_item_name": "Es wurde kein Artikelname in der aktuellen Sprache angegeben.",
    "category_and_items_language": "Kategorie- und Artikelsprache",
    "auto_translate_title": "Die automatische Menüübersetzung kann nur auf bereits gespeicherte Kategorien und Elemente angewendet werden. Es wird empfohlen, die Ausgangssprache anzugeben.",
    "auto_translate_description": "Diese Funktion nutzt Google Translate. Die Übersetzungen sind nicht immer korrekt, daher lohnt es sich, sie zu überprüfen.",
    "translate_from": "Übersetzen von",
    "translate_to": "Zu diesen Sprachen",
    "auto_translate_error_invalid_languages": "Ungültige Sprachen für die Übersetzung ausgewählt",
    "auto_translate_success": "Menü erfolgreich übersetzt",
    "auto_translate_error_permission": "Sie haben keine Berechtigung, das Menü zu übersetzen",
    "auto_translate_error_generic": "Bei der Übersetzung ist ein unbekannter Fehler aufgetreten.",
    "auto_translate_feature_not_available": "Die automatische Menüübersetzung ist nur mit einem PRO-Abonnement verfügbar.",
    "change_subscription_plan": "Abonnementplan ändern",
    "menu_headers": "Menüköpfe und -fußzeilen",
    "menu_header_editor_title": "Menükopf- und -fußzeilen sind die Texte, die oben und unten in Ihrem Online-Menü erscheinen und die Sie frei festlegen können.",
    "menu_header_feature_not_available": "Die Bearbeitung von Menükopf- und -fußzeile ist nur mit einem PRO-Abonnement möglich.",
    "menu_header": "Menüüberschrift",
    "menu_header_placeholder": "Verfassen Sie eine kurze Begrüßungsnachricht oder weisen Sie auf ein aktuelles Angebot hin.",
    "menu_footer": "Menüfuß",
    "menu_footer_placeholder": "Sie können Informationen über Servicegebühren, Allergene oder andere wichtige Informationen eingeben.",
    "menu_header_save_success": "Menükopf und -fuß erfolgreich gespeichert",
    "menu_header_save_error": "Beim Speichern der Menükopf- und -fußzeile ist ein Fehler aufgetreten.",
    "menu_header_permission_error": "Sie haben keine Berechtigung, die Menükopf- und -fußzeile zu bearbeiten.",
    "menu_header_generic_error": "Beim Laden der Menükopf- und -fußzeile ist ein unbekannter Fehler aufgetreten.",
    "menu_import": "Menü importieren",
    "import_success": "Der letzte Import wurde erfolgreich abgeschlossen.",
    "import_failed": "Der letzte Import ist aufgrund eines serverseitigen Exports fehlgeschlagen.",
    "attached_document": "Beigefügtes Dokument",
    "allowed_file_types": "Zulässige Dateitypen: .doc, .docx, .pdf, .txt, .html",
    "import_language_helpertext": "Dokumentsprache",
    "import_options_pro_helpertext": "Die Optionen „Deaktivieren“ und „Hinzufügen“ sind nur mit einem PRO-Abonnement verfügbar.",
    "import_option_helpertexts": {
        "replace": "Die aktuellen Menükategorien und -elemente werden gelöscht und durch das neu generierte Menü ersetzt.",
        "deactivate": "Die aktuellen Menükategorien und -elemente werden deaktiviert und das neu generierte Menü wird hinzugefügt.",
        "add": "Das aktuelle Menü bleibt bestehen, und die neuen Menüpunkte werden nach dem aktuellen Menü angehängt."
    },
    "import_type": "Importtyp",
    "import_options": {
        "replace": "Ersetzen",
        "deactivate": "Deaktivieren",
        "add": "Hinzufügen"
    },
    "menu_import_tooltip": "Laden Sie eine Datei mit Ihrer Speisekarte hoch oder geben Sie einen Link zu einer Webseite mit der Speisekarte an. Achten Sie in beiden Fällen darauf, dass die Speisekarte im Dokument als Text vorliegt, da wir keine Bilder verarbeiten können. Nach dem Start des Imports verarbeitet unsere KI die Datei automatisch und erstellt die neue Speisekarte in der ausgewählten Sprache. Wenn Sie die Gerichte später in weitere Sprachen übersetzen möchten, nutzen Sie die Funktion „Speisekartenübersetzung“. Der Importvorgang dauert 5–10 Minuten.",
    "menu_import_replace_warning": "Die aktuell gewählte Importmethode löscht das bestehende Menü und ersetzt es durch das neue. Bitte stellen Sie sicher, dass die hochgeladene Datei das korrekte Format und den korrekten Inhalt aufweist, da dieser Vorgang nicht rückgängig gemacht werden kann! Wenn Sie das bestehende Menü nicht löschen möchten, wählen Sie bitte eine andere Importmethode.",
    "start_import": "Import",
    "file_or_url_required": "Bitte wählen Sie eine Datei aus oder geben Sie eine Website-URL an.",
    "file_and_url_error": "Sie können entweder eine Datei oder eine URL angeben, nicht beides.",
    "import_site_url": "Website-URL",
    "import_in_progress": "Import läuft",
    "import_duration": "Dies kann einige Minuten dauern.",
    "listing_manager_info": {
        "summary": "Mit Mozrest verwalten Sie Ihre Einträge und Bewertungen ganz einfach über eine einzige Plattform. Sparen Sie Zeit, verbessern Sie Ihre Online-Reputation und steigern Sie Ihre betriebliche Effizienz.",
        "bullet_1": "Aktualisieren Sie Ihre Einträge auf Tripadvisor, Apple Maps, Google, Facebook, Quandoo und Bing im Handumdrehen mit nur einem Klick.",
        "bullet_2": "Erhalten Sie Echtzeitbenachrichtigungen, wenn Ihre Öffnungszeiten und Ihre Verfügbarkeit nicht übereinstimmen, um Enttäuschungen bei den Gästen und negative Bewertungen zu vermeiden.",
        "bullet_3": "Überprüfen Sie Ihren Eintrag kurz auf Vollständigkeit, um sicherzustellen, dass alle wichtigen Angaben – wie Fotos, Speisekarten und Öffnungszeiten – korrekt und aktuell sind.",
        "setup_button": "Mozrest einrichten",
        "pro_warning": "Diese Funktion erfordert ein PRO-Abonnement."
    },
    "listing_manager_tabs": {
        "Listing": "Auflistung",
        "ListingAnalytics": "Listing-Analyse",
        "ReviewsPage": "Rezensionen",
        "ReviewAnalytics": "Analyse der Überprüfung",
        "ReplyTemplates": "Antwortvorlagen",
        "Notifications": "Benachrichtigungen"
    },
    "review_manager_set_title": "Review-Manager einrichten",
    "review_manager_set_description": "Bitte geben Sie einige Informationen zu Ihrem Unternehmen an, damit wir Ihre Grundeinstellungen erstellen können.",
    "confirm_settings": "Einstellungen bestätigen",
    "confirm_delete_item": "Element löschen?",
    "confirm_delete_category": "Kategorie und alle Elemente löschen?",
    "reorder_disabled_search": "Neuanordnung während der Suche deaktiviert",
};

export default menuDe;
